export const selectCurrentTab = (state) => state.navigation.currentTab;
